// Export the Component Definition for use in Contentful Studio
export {LinkContentfulComponentDefinition} from './LinkContentfulDefinition';
export type {LinkProps} from './Link';
export {default} from './Link';
